// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    add_message_button: 'Ajouter un message',
    AdditionalRecipients: 'Destinataires supplémentaires',
    Ai_disabled_button: 'Commencez à taper pour activer les commandes IA',
    Append: 'Ajouter',
    Apply: 'Appliquer',
    approval_request_approved_comment: 'approuvé avec un message',
    approval_request_link: 'demande d\'approbation',
    approval_request_reject_comment: 'rejeté avec un message',
    Approve: 'Approuver',
    Approver_Approved: 'approuvé',
    Approver_HasNotSeen: 'non lu',
    Approver_NoAction: 'aucune action',
    Approver_NotApproved: 'vu, approbation en attente',
    Approver_Rejected: 'rejeté',
    ApproversGroupTitle: 'Approbateurs',
    Attachment_Delete: 'Le fichier \'{0}\' a été supprimé.',
    BaseNotificationRule: 'Basé sur la règle de notification',
    BeforePageUnloadMessage: 'Vos modifications seront perdues. Voulez-vous quitter cette page sans enregistrer les modifications ?',
    Cancel: 'Annuler',
    ChangeTone: 'Changer le ton',
    Close: 'Fermer',
    ContactAdministrator: 'Veuillez contacter votre administrateur',
    ContinueWriting: 'Continuer à écrire avec l\'IA',
    Delete: 'Supprimer',
    DeleteAttachmentContentTemplate: 'Êtes-vous sûr de vouloir supprimer la pièce jointe \'{0}\' ?',
    DeleteAttachmentTitle: 'Supprimer la pièce jointe',
    Discard: 'Ignorer',
    Download: 'Télécharger',
    DropHere: 'Déposez les fichiers ici',
    Edit: 'Modifier',
    edit_actions: 'Appuyez sur ctrl + entrée pour <a apply>Appliquer</a> ou esc pour <a>Annuler</a>',
    email_only_mention_title: 'Cet utilisateur sera notifié uniquement par email',
    Error: 'Erreur',
    FilePlural: '1#{0} fichier#{0} fichiers',
    FileUploadError: 'Erreur',
    FileVersion: 'Version ',
    FileVersionShort: 'ver ',
    Formal: 'Formel',
    FreeSpaceTemplate: 'Vous avez utilisé {0} Mo sur {1} Mo.',
    Friendly: 'Amical',
    GeneratedByAi: 'Généré par l\'IA...',
    HideFiles: 'Masquer les fichiers',
    ImproveSpelling: 'Améliorer l\'orthographe et la grammaire',
    ImproveWriting: 'Améliorer la rédaction',
    mention_title: 'Mentionner quelqu\'un',
    Message_Delete: 'Le message a été supprimé.',
    message_maxLength_description: 'Un message peut contenir jusqu\'à 10 000 caractères.',
    message_maxLength_title: 'Le message est trop long',
    MessageDeleteConfirmation: 'Supprimer ce post ?',
    messageEdited: '(modifié)',
    MessageEditedBy: 'Modifié par ',
    messagePlaceholderText: 'Ajouter un message, déposer des fichiers ou @mentionner quelqu\'un',
    MultipleApproversTemplate: '{0} sur {1} {2}',
    MyComputer: 'Mon ordinateur',
    NewMessageWatermark: 'Saisir un message ou déposer des fichiers...',
    NewPost: '1#{0} nouveau post#{0} nouveaux posts',
    No: 'Non',
    NoMatchRecipients: 'Membre non trouvé',
    NoPermissionToEditMessage: 'Désolé, vous n\'avez pas l\'autorisation de modifier ce message',
    Notification: 'Notification',
    Notify: 'Notifier',
    NotifyLabel: 'Notifier...',
    NotProjectMembers: 'Non-membres du projet',
    OneDrive: 'OneDrive',
    OneDriveFilePicker: 'Sélecteur de fichiers OneDrive',
    Optimistic: 'Optimiste',
    Or: 'ou',
    PluralApproved: '1#approuvé#approuvés',
    PluralRejected: '1#{0} rejeté#{0} rejetés',
    Post: 'Publier',
    PostWatingForApproval: 'Le post est en attente d\'approbation',
    PreviewImages: 'Aperçu des images',
    Professional: 'Professionnel',
    ProjectMembers: 'Membres du projet',
    Reject: 'Rejeter',
    Replace: 'Remplacer',
    RequestApprovalLabel: 'Demander l\'approbation',
    Retry: 'Réessayer',
    SharePoint: 'SharePoint',
    SharePointFilePicker: 'Sélecteur de fichiers SharePoint',
    ShowFiles: 'Afficher les fichiers',
    ShowNext: 'Afficher précédent',
    SingleApprovedTemplate: 'Approuvé par {0}',
    SingleApprovedTemplate_You: 'Approuvé par vous.',
    SingleApproverTemplate: 'En attente d\'approbation de {0}',
    SingleRejectedTemplate: 'Rejeté par {0}',
    SingleRejectedTemplate_You: 'Rejeté par vous.',
    Straightforward: 'Direct',
    Summarize: 'Résumer',
    SummarizeBulletPoints: 'Résumer en points clés',
    TabFiles: 'Fichiers',
    TabMessages: 'Messages',
    Teams: 'Teams',
    Undo: 'Annuler',
    UploadedBy: 'par ',
    Yes: 'Oui',
    You: 'Vous',
};
